var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounGeodesicDome2185259Cleaned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes elasticMove{0%,to{transform:scale(1)}50%{transform:scale(1.2)}}@keyframes counterElasticMove{0%,to{transform:scale(1)}50%{transform:scale(.8)}}.counter-junction,.junction{transform-origin:center}.junction{animation:elasticMove 2s infinite ease-in-out}.counter-junction{animation:counterElasticMove 2s infinite ease-in-out}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.434,
    cy: 47.216,
    r: 1,
    className: "junction"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.125,
    cy: 30.741,
    r: 1,
    className: "junction"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.884,
    cy: 21.31,
    r: 1,
    className: "junction"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.447,
    cy: 33.122,
    r: 1,
    className: "junction"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.467,
    cy: 52.96,
    r: 1,
    className: "junction"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.783,
    cy: 61.142,
    r: 1,
    className: "junction"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.803,
    cy: 80.856,
    r: 1,
    className: "junction"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.826,
    cy: 75.044,
    r: 1,
    className: "junction"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.586,
    cy: 77.215,
    r: 1,
    className: "junction"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.984,
    cy: 55.693,
    r: 1,
    className: "junction"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.434,
    cy: 37.216,
    r: 1,
    className: "counter-junction"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.125,
    cy: 20.741,
    r: 1,
    className: "counter-junction"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.884,
    cy: 11.31,
    r: 1,
    className: "counter-junction"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.447,
    cy: 23.122,
    r: 1,
    className: "counter-junction"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.467,
    cy: 42.96,
    r: 1,
    className: "counter-junction"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.783,
    cy: 51.142,
    r: 1,
    className: "counter-junction"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.803,
    cy: 70.856,
    r: 1,
    className: "counter-junction"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.826,
    cy: 65.044,
    r: 1,
    className: "counter-junction"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.586,
    cy: 67.215,
    r: 1,
    className: "counter-junction"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.984,
    cy: 45.693,
    r: 1,
    className: "counter-junction"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.434 47.216a.25.25 0 0 0-.074-.178L78.125 30.741v-.001c-.01-.01-.023-.007-.033-.016l-.023-.01c-.018-.012-.025-.033-.045-.04h-.002l-.002-.002-29.241-9.431h-.004c-.024-.007-.05.007-.075.007h-.006c-.029.001-.057-.012-.085-.001l-.006.006h-.008L23.447 33.122c-.019.009-.023.03-.039.043s-.037.012-.05.027L7.467 52.96c-.016.02-.011.045-.02.067-.012.027-.025.05-.026.08-.001.011-.007.019-.005.029.002.024.021.043.03.066.009.021.003.046.018.065l6.316 8.182.003.001.001.004 16.02 19.714c.005.007.016.004.021.01a.2.2 0 0 0 .072.048c.013.006.018.021.032.025a.23.23 0 0 0 .121.004l27.023-5.812 25.76 2.171.02.001a.2.2 0 0 0 .096-.02c.006-.002.006-.008.012-.011q.023-.012.043-.028c.02-.016.021-.023.033-.037.014-.016.031-.026.041-.046l.006-.013.002-.001 10.398-21.522c.004-.007 0-.014.002-.021.004-.009.012-.013.016-.022l-.002-.004c.004-.012-.002-.022-.002-.034.002-.012.012-.018.012-.029zM52.127 30.348l18.764 19.321-32.231 2.222zM38.163 51.742 24.594 34.797l26.984-4.515zm14.536-21.524 24.896.931-6.254 18.266zm-27.105 3.906 22.979-12.291 3.164 7.917zm12.184 17.938L14.41 60.868l9.802-25.75zm33.22-1.9-13.977 24.59L38.688 52.39zm7.008-18.669 14.711 23.93-20.949-5.713zm14.996 23.441L79.457 32.897l13.479 14.42zM52.256 29.7l-3.125-7.817 27.009 8.711zM24.25 34.274l-.367-.805 15.909-7.508zm-.756-.453.345.756-9.777 10.979zm-.077 1.98-9.512 24.991-5.918-7.665zm14.395 16.782-7.923 27.898L14.392 61.41zm.485.119 18.308 22.332-26.253 5.646zm33.115-2.253 11.055 26.634-24.996-2.106zm11.459 26.308-11-26.501 21.033 5.736z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounGeodesicDome2185259Cleaned);
export default __webpack_public_path__ + "static/media/noun-geodesic-dome-2185259.cleaned.b1f6f09af5fcd81a4547bcd266c245c4.svg";
export { ForwardRef as ReactComponent };